export const defaultColumns = [
  {label: 'Transação', value: 'protocol_number' },
  {label: 'Tipo', value: 'eventable_type' },
  {label: 'Detalhes', value: 'details'},
  {label: 'Placa do Veículo', value: 'license_plate'},
  {label: 'Vlr. Total', value: 'total_amount' },
  {label: 'Método de captura', value: 'capture_method'},
  {label: 'Tarifas', value: 'fee_total_amount' },
  {label: 'Ret. IR', value: 'income_tax_total' },
  {label: 'Cartão', value: 'card' },
  {label: 'Responsável', value: 'buyer' },
  {label: 'Data e Hora', value: 'created_at'},
  { value: 'actions', label: 'Ações' },
]
